import { defineMobileFormWindow } from "@app/overlay";
import {
    StockPlacementFilterForm,
    type StockPlacementFilterFormProps,
} from "./components/StockPlacementFilter/StockPlacementFilterForm";

/** Реестр overlay-окон списка приходных ордеров для размещения ТМЦ. */
export const stockPlacementListWindows = {
    filter: defineMobileFormWindow<StockPlacementFilterFormProps>({
        key: "stock.placement.filter",
        title: "Фильтр ПО для размещения ТМЦ",
        component: StockPlacementFilterForm,
    }),
};
